/**
 * Утилиты для работы с API токеном (для эндпоинтов, защищённых X-API-Token,
 * отдельно от пользовательского JWT-логина хаба).
 */

export const getApiToken = (): string | null => {
  if (process.env.REACT_APP_API_TOKEN) {
    return process.env.REACT_APP_API_TOKEN;
  }
  if (typeof window !== 'undefined') {
    return localStorage.getItem('api_token') || localStorage.getItem('API_TOKEN');
  }
  return null;
};

export const setApiToken = (token: string): void => {
  if (typeof window !== 'undefined') {
    localStorage.setItem('api_token', token);
  }
};

export const removeApiToken = (): void => {
  if (typeof window !== 'undefined') {
    localStorage.removeItem('api_token');
    localStorage.removeItem('API_TOKEN');
  }
};
